import { de } from 'date-fns/locale';
import {
  BadgeImage1,
  BadgeImage2,
  BadgeImage3,
  BadgeImage4,
  Student1,
  Student2,
  Student3,
  Student4,
  Student5,
  Student6,
} from 'src/images';

export const transactions = [
  {
    id: '1',
    studentName: 'Chieko Chute',
    email: 'chieko@mail.com',
    phoneNumber: '+1 123 4567890',
    grade: '3',
    balanceUSD: '500',
    reason: 'Tardy Fine',
    balanceAfterTransaction: '6,000',
    date: '15/10/2024',
  },
  {
    id: '2',
    studentName: 'Annabel Rohan',
    email: 'rohan_anna@mail.com',
    phoneNumber: '+1 123 4567890',
    grade: '3',
    balanceUSD: '-200',
    reason: 'Weekly Performance Reward',
    balanceAfterTransaction: '6,060',
    date: '15/10/2024',
  },
  {
    id: '3',
    studentName: 'Pedro Huard',
    email: 'pedrohuar@mail.com',
    phoneNumber: '+1 123 4567890',
    grade: '3',
    balanceUSD: '300',
    reason: 'Headphone Purchase',
    balanceAfterTransaction: '5,560',
    date: '15/10/2024',
  },
  {
    id: '4',
    studentName: 'Jamel Eusebio',
    email: 'eusebio234@mail.com',
    phoneNumber: '+1 123 4567890',
    grade: '3',
    balanceUSD: '-500',
    reason: 'Good Behavior Reward',
    balanceAfterTransaction: '5,760',
    date: '15/10/2024',
  },
  {
    id: '5',
    studentName: 'Augustina Midgett',
    email: 'midgett245@mail.com',
    phoneNumber: '+1 123 4567890',
    grade: '3',
    balanceUSD: '500',
    reason: 'Loan Repaymant',
    balanceAfterTransaction: '5,460',
    date: '15/10/2024',
  },
];

export const transactionTypes = [
  {
    id: '1',
    name: 'Debit',
    description: 'Money deducted from a student’s balance.',
    amount: '-100',
    transactionCategory: 'Debit',
  },
  {
    id: '2',
    name: 'Credit',
    description: 'Money deducted from a student’s balance.',
    amount: '+100',
    transactionCategory: 'Credit',
  },
  {
    id: '3',
    name: 'Debit',
    description: 'Money deducted from a student’s balance.',
    amount: '-100',
    transactionCategory: 'Debit',
  },
  {
    id: '4',
    name: 'Credit',
    description: 'Money deducted from a student’s balance.',
    amount: '+100',
    transactionCategory: 'Credit',
  },
  {
    id: '5',
    name: 'Debit',
    description: 'Money deducted from a student’s balance.',
    amount: '-100',
    transactionCategory: 'Debit',
  },
  {
    id: '6',
    name: 'Credit',
    description: 'Money deducted from a student’s balance.',
    amount: '+100',
    transactionCategory: 'Credit',
  },
];

export const students = [
  {
    id: '1',
    name: 'Chieko Chute',
    email: 'chieko@mail.com',
  },
  {
    id: '2',
    name: 'Annabel Rohan',
    email: 'rohan_anna@mail.com',
  },
  {
    id: '3',
    name: 'Pedro Huard',
    email: 'pedrohuar@mail.com',
  },
  {
    id: '4',
    name: 'Jamel Eusebio',
    email: 'eusebio234@mail.com',
  },
  {
    id: '5',
    name: 'Augustina Midgett',
    email: 'midgett245@mail.com',
  },
];

export const studentsList = [
  {
    id: '1',
    name: 'Chieko Chute',
    email: 'chieko@mail.com',
    phoneNumber: '+1 123 4567890',
    grade: '3',
    balanceUSD: '+500',
    badgeImage: BadgeImage1,
  },
  {
    id: '2',
    name: 'Annabel Rohan',
    email: 'rohan_anna@mail.com',
    phoneNumber: '+1 123 4567890',
    grade: '3',
    balanceUSD: '-500',
    badgeImage: BadgeImage2,
  },
  {
    id: '3',
    name: 'Pedro Huard',
    email: 'pedrohuar@mail.com',
    phoneNumber: '+1 123 4567890',
    grade: '3',
    balanceUSD: '+500',
    badgeImage: BadgeImage3,
  },
  {
    id: '4',
    name: 'Jamel Eusebio',
    email: 'eusebio234@mail.com',
    phoneNumber: '+1 123 4567890',
    grade: '3',
    balanceUSD: '-500',
    badgeImage: BadgeImage3,
  },
  {
    id: '5',
    name: 'Augustina Midgett',
    email: 'midgett245@mail.com',
    phoneNumber: '+1 123 4567890',
    grade: '3',
    balanceUSD: '+500',
    badgeImage: BadgeImage1,
  },
  {
    id: '6',
    name: 'Chieko Chute',
    email: 'chieko@mail.com',
    phoneNumber: '+1 123 4567890',
    grade: '3',
    balanceUSD: '+500',
    badgeImage: BadgeImage1,
  },
  {
    id: '7',
    name: 'Annabel Rohan',
    email: 'rohan_anna@mail.com',
    phoneNumber: '+1 123 4567890',
    grade: '3',
    balanceUSD: '-500',
    badgeImage: BadgeImage2,
  },
  {
    id: '8',
    name: 'Pedro Huard',
    email: 'pedrohuar@mail.com',
    phoneNumber: '+1 123 4567890',
    grade: '3',
    balanceUSD: '+500',
    badgeImage: BadgeImage3,
  },
  {
    id: '9',
    name: 'Jamel Eusebio',
    email: 'eusebio234@mail.com',
    phoneNumber: '+1 123 4567890',
    grade: '3',
    balanceUSD: '-500',
    badgeImage: BadgeImage4,
  },
  {
    id: '10',
    name: 'Augustina Midgett',
    email: 'midgett245@mail.com',
    phoneNumber: '+1 123 4567890',
    grade: '3',
    balanceUSD: '+500',
    badgeImage: BadgeImage1,
  },
];

export const teachersList = [
  {
    id: '1',
    firstName: 'Anabella',
    lastName: 'Cortez',
    email: 'chieko@mail.com',
    grade: '2',
    teacherId: '#1001',
  },
  {
    id: '2',
    firstName: 'Annabel',
    lastName: 'Rohan',
    email: 'rohan_anna@mail.com',
    grade: '3',
    teacherId: '#1002',
  },
  {
    id: '3',
    firstName: 'Pedro',
    lastName: 'Huard',
    email: 'pedrohuar@mail.com',
    grade: '3',
    teacherId: '#1003',
  },
  {
    id: '4',
    firstName: 'Jamel',
    lastName: 'Eusebio',
    email: 'eusebio234@mail.com',
    grade: '3',
    teacherId: '#1004',
  },
  {
    id: '5',
    firstName: 'Augustina',
    lastName: 'Midgett',
    email: 'midgett245@mail.com',
    grade: '3',
    teacherId: '#1004',
  },
  {
    id: '6',
    firstName: 'Anabella',
    lastName: 'Cortez',
    email: 'chieko@mail.com',
    grade: '2',
    teacherId: '#1001',
  },
  {
    id: '7',
    firstName: 'Annabel',
    lastName: 'Rohan',
    email: 'rohan_anna@mail.com',
    grade: '3',
    teacherId: '#1002',
  },
  {
    id: '8',
    firstName: 'Pedro',
    lastName: 'Huard',
    email: 'pedrohuar@mail.com',
    grade: '3',
    teacherId: '#1003',
  },
  {
    id: '9',
    firstName: 'Jamel',
    lastName: 'Eusebio',
    email: 'eusebio234@mail.com',
    grade: '3',
    teacherId: '#1004',
  },
  {
    id: '10',
    firstName: 'Augustina',
    lastName: 'Midgett',
    email: 'midgett245@mail.com',
    grade: '3',
    teacherId: '#1004',
  },
];

export const viewStudentTabs = [
  {
    title: 'Transactions',
    label: 'Transactions',
  },
  {
    title: 'Loans',
    label: 'Loans Requests',
  },
  {
    title: 'STREET Cred',
    label: 'STREET Cred',
  },
  {
    title: 'Whammies',
    label: 'Whammies',
  },
];

export const settingsTabs = [
  {
    title: 'Edit Profile',
    label: 'Edit Profile',
  },
  {
    title: 'Password',
    label: 'Password',
  },
];

export const transactionsTypes = [
  {
    title: 'Recent Transactions',
    label: 'Recent Transactions',
  },
  {
    title: 'Manage Transaction Type',
    label: 'Manage Transaction Type',
  },
];

export const financialSimulationsTabs = [
  {
    title: 'Student Challenges',
    label: 'Student Challenges',
  },
  {
    title: 'Scenario Library',
    label: 'Scenario Library',
  },
];

export const streetCredTabs = [
  {
    title: 'Student Behaviors',
    label: 'Student Behaviors',
  },
  {
    title: 'Manage Behavior Types',
    label: 'Manage Behavior Types',
  },
];

export const badges = [
  {
    id: '01',
    badgeName: 'Top Performer',
    badgeUrl: BadgeImage1,
    description: 'Awarded for achieving 500+ points.',
  },
  {
    id: '02',
    badgeName: 'Most Improved',
    badgeUrl: BadgeImage2,
    description: 'Recognizes significant progress in performance.',
  },
  {
    id: '03',
    badgeName: 'Perfect Attendance',
    badgeUrl: BadgeImage3,
    description: 'Given for zero tardies or absences during a term.',
  },
  {
    id: '04',
    badgeName: 'Creative Thinker',
    badgeUrl: BadgeImage4,
    description: 'Awarded for exceptional creativity in projects.',
  },
  {
    id: '05',
    badgeName: 'Team Player',
    badgeUrl: BadgeImage1,
    description: 'Recognizes outstanding collaboration in group work.',
  },
];
export const streenCredData = [
  {
    id: '01',
    title: 'Exemplary Participation in Class',
    date: '05/11/2024',
    amount: '500',
    type: 'Highlight',
    balanceAfterTransaction: '1,135',
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
    },
    description: 'Tardy Fine',
  },
  {
    id: '02',
    title: 'Disruptive During Class',
    date: '05/11/2024',
    amount: '-500',
    type: 'Challenges',
    balanceAfterTransaction: '1,135',
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
    },
    description: 'Tardy Fine',
  },
  {
    id: '03',
    title: 'Exemplary Participation in Class',
    date: '05/11/2024',
    amount: '500',
    type: 'Highlight',
    balanceAfterTransaction: '1,135',
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
    },
    description: 'Weekly Performance Reward',
  },
  {
    id: '04',
    title: 'Disruptive During Class',
    date: '05/11/2024',
    amount: '-500',
    type: 'Challenges',
    balanceAfterTransaction: '1,135',
    student: {
      name: 'Augustina Midgett',
      image: Student2,
      email: 'rohan_anna@mail.com',
    },
    description: 'Tardy Fine',
  },
  {
    id: '05',
    title: 'Exemplary Participation in Class',
    date: '05/11/2024',
    amount: '500',
    type: 'Highlight',
    balanceAfterTransaction: '1,135',
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
    },
    description: 'Tardy Fine',
  },
  {
    id: '06',
    title: 'Disruptive During Class',
    date: '05/11/2024',
    amount: '-500',
    type: 'Challenges',
    balanceAfterTransaction: '1,135',
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
    },
    description: 'Tardy Fine',
  },
  {
    id: '07',
    title: 'Exemplary Participation in Class',
    date: '05/11/2024',
    amount: '500',
    type: 'Highlight',
    balanceAfterTransaction: '1,135',
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
    },
    description: 'Tardy Fine',
  },
  {
    id: '08',
    title: 'Disruptive During Class',
    date: '05/11/2024',
    amount: '-500',
    type: 'Challenges',
    balanceAfterTransaction: '1,135',
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
    },
    description: 'Tardy Fine',
  },
  {
    id: '09',
    title: 'Exemplary Participation in Class',
    date: '05/11/2024',
    amount: '500',
    type: 'Highlight',
    balanceAfterTransaction: '1,135',
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
    },
    description: 'Tardy Fine',
  },
  {
    id: '10',
    title: 'Disruptive During Class',
    date: '05/11/2024',
    amount: '-500',
    type: 'Challenges',
    balanceAfterTransaction: '1,135',
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
    },
    description: 'Tardy Fine',
  },
];

export const financialSimulations = [
  {
    id: '1',
    scenario: 'Restocking Essential',
    duration: '2 Weeks',
    amount: '500',
    status: 'In Progress',
    satrtedDate: new Date('2024-11-02'),
    endDate: new Date('2024-11-20'),
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
      currentBalance: '200',
    },
    loanRequested: false,
  },
  {
    id: '2',
    scenario: 'Field Trip Adventure',
    duration: '2 Weeks',
    amount: '500',
    status: 'Completed',
    satrtedDate: new Date('2024-11-02'),
    endDate: new Date('2024-11-20'),
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
      currentBalance: '500',
    },
  },
  {
    id: '3',
    scenario: 'Forgot Return',
    duration: '4 Weeks',
    amount: '500',
    status: 'Overdue',
    satrtedDate: new Date('2024-11-02'),
    endDate: new Date('2024-11-20'),
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
      currentBalance: '200',
    },
  },
  {
    id: '4',
    scenario: 'Restocking Essential',
    duration: '2 Weeks',
    amount: '500',
    status: 'In Progress',
    satrtedDate: new Date('2024-11-02'),
    endDate: new Date('2024-11-20'),
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
      currentBalance: '200',
    },
    loanRequest: {
      status: 'requested',
      requestDate: new Date('2024-11-07'),
    },
  },
  {
    id: '5',
    scenario: 'Restocking Essential',
    duration: '2 Weeks',
    amount: '500',
    status: 'In Progress',
    satrtedDate: new Date('2024-11-02'),
    endDate: new Date('2024-11-20'),
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
      currentBalance: '200',
    },
    loanRequest: {
      status: 'approved',
      requestDate: new Date('2024-11-07'),
      approvedDate: new Date('2024-11-08'),
    },
  },
  {
    id: '6',
    scenario: 'Field Trip Adventure',
    duration: '2 Weeks',
    amount: '500',
    status: 'Completed',
    satrtedDate: new Date('2024-11-02'),
    endDate: new Date('2024-11-20'),
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
      currentBalance: '200',
    },
  },
  {
    id: '7',
    scenario: 'Forgot Return',
    duration: '4 Weeks',
    amount: '500',
    status: 'Overdue',
    satrtedDate: new Date('2024-11-02'),
    endDate: new Date('2024-11-20'),
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
      currentBalance: '200',
    },
  },
  {
    id: '8',
    scenario: 'Restocking Essential',
    duration: '2 Weeks',
    amount: '500',
    status: 'In Progress',
    satrtedDate: new Date('2024-11-02'),
    endDate: new Date('2024-11-20'),
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
      currentBalance: '500',
    },
  },
  {
    id: '9',
    scenario: 'Restocking Essential',
    duration: '2 Weeks',
    amount: '500',
    status: 'Completed',
    satrtedDate: new Date('2024-11-02'),
    endDate: new Date('2024-11-20'),
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
      currentBalance: '500',
    },
    loanRequest: {
      status: 'approved',
      requestDate: new Date('2024-11-07'),
      approvedDate: new Date('2024-11-08'),
    },
  },
];

export const scenarioLibraries = [
  {
    id: '1',
    title: 'Restocking Essential',
    description: 'You’ve run out of essential school supplies like notebooks, pens, or pencils.',
    amount: '500',
  },
  {
    id: '2',
    title: 'Field Trip Adventure',
    description: 'You’ve run out of essential school supplies like notebooks, pens, or pencils.',
    amount: '150',
  },
  {
    id: '3',
    title: 'Forgot Return',
    description: 'You forgot to return a library book on time and have incurred a 20 $D late fee.',
    amount: '300',
  },
  {
    id: '4',
    title: 'Medical Expense',
    description: 'You had an unexpected medical expense and need to spend 150 $D for a doctor’s visit.',
    amount: '300',
  },
  {
    id: '5',
    title: 'Restocking Essential',
    description: 'You’ve run out of essential school supplies like notebooks, pens, or pencils.',
    amount: '500',
  },
  {
    id: '6',
    title: 'Field Trip Adventure',
    description: 'You’ve run out of essential school supplies like notebooks, pens, or pencils.',
    amount: '150',
  },
  {
    id: '7',
    title: 'Forgot Return',
    description: 'You forgot to return a library book on time and have incurred a 20 $D late fee.',
    amount: '300',
  },
  {
    id: '8',
    title: 'Medical Expense',
    description: 'You had an unexpected medical expense and need to spend 150 $D for a doctor’s visit.',
    amount: '300',
  },
];

export const TRANSACTION_TABLE_HEAD = [
  { id: 'reason', label: 'Reason', alignRight: false },
  { id: 'date', label: 'Date', alignRight: false },
  { id: 'balanceUSD', label: 'Amount $D', alignRight: false },
  { id: 'balanceAfterTransaction', label: 'Balance After Transaction', alignRight: false },
];
export const TRANSACTION_TABLE_HEAD2 = [
  { id: 'reason', label: 'Reason', alignRight: false },
  { id: 'date', label: 'Date', alignRight: false },
  { id: 'balanceUSD', label: 'Amount $D', alignRight: false },
  { id: 'balanceAfterTransaction', label: 'Balance After Transaction', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
];

export const REQUESTS_TRANSACTION_TABLE_HEAD = [
  { id: 'reason', label: 'Reason', alignRight: false },
  { id: 'date', label: 'Date', alignRight: false },
  { id: 'balanceUSD', label: 'Amount $D', alignRight: false },
  { id: 'balanceAfterTransaction', label: 'Balance After Transaction', alignRight: false },
  { id: 'actions', label: 'Actions', alignRight: false },
];
// export const LOAN_REQUESTS_TABLE_HEAD  = [
//   { id: 'reason', label: 'Loan Purpose', alignRight: false },
//   { id: 'amount', label: 'Loan Amount', alignRight: false },
//   { id: 'term_months', label: 'Repayment Period', alignRight: false },
//   { id: 'status', label: 'Status', alignRight: false },
// ];

export const LOAN_REQUESTS_TABLE_HEAD = [
  { id: 'loanPurpose', label: 'Loan Purpose', alignRight: false },
  { id: 'loanAmount', label: 'Loan Amount', alignRight: false },
  { id: 'repaymentPeriod', label: 'Repayment Period', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
];

export const STREET_CRED_TABLE_HEAD = [
  { id: 'title', label: 'Title', alignRight: false },
  { id: 'date', label: 'Date', alignRight: false },
  { id: 'amount', label: 'Amount', alignRight: false },
  { id: 'type', label: 'Type', alignRight: false },
];

export const FINANCIAL_SIMULATIONS_TABLE_HEAD = [
  { id: 'scenario', label: 'Scenario', alignRight: false },
  { id: 'duration', label: 'Duration', alignRight: false },
  { id: 'amount', label: 'Amount', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'actions', label: 'Actions', alignRight: false, showActions: true },
];

export const getStatusColor = (status) => {
  switch (status.toLowerCase()) {
    case 'Pending':
      return {
        bgcolor: 'secondary.main',
        color: 'secondary.contrastText',
        label: 'Pending',
      };
    case 'Approved':
      return {
        bgcolor: 'info.main',
        color: 'info.contrastText',
        label: 'Approved',
      };
    case 'paid':
      return {
        bgcolor: 'success.main',
        color: 'success.contrastText',
        label: 'Paid',
      };
    case 'overdue':
      return {
        bgcolor: 'error.light',
        color: 'error.contrastText',
        label: 'Overdue',
      };
    case 'cancelled':
      return {
        bgcolor: 'warning.light',
        color: 'warning.contrastText',
        label: 'Cancelled',
      };
    default:
      return {
        bgcolor: 'grey.500',
        color: 'grey.contrastText',
        label: status,
      };
  }
};

export const loanRequests = [
  {
    id: 0,
    student: {
      name: 'Chieko Chute',
      image: Student1,
      email: 'chieko@mail.com',
    },
    repaymentPeriod: '4 Weeks',
    loanPurpose: 'Need for project',
    loanAmount: 100,
    interest: '5%',
    status: 'Pending',
    date: '15/10/2024',
    returned: '0',
  },
  {
    id: 1,
    student: {
      name: 'Annabel Rohan',
      image: Student2,
      email: 'rohan_anna@mail.com',
    },
    repaymentPeriod: '4 Weeks',
    loanPurpose: 'Need for project',
    loanAmount: 500,
    interest: '5%',
    status: 'Pending',
    date: '15/10/2024',
    returned: '200',
  },
  {
    id: 2,
    student: {
      name: 'Pedro Huard',
      image: Student3,
      email: 'pedrohuar@mail.com',
    },
    repaymentPeriod: '4 Weeks',
    loanPurpose: 'Need for project',
    loanAmount: 100,
    interest: '5%',
    status: 'Pending',
    date: '15/10/2024',
    returned: '0',
  },
  {
    id: 3,
    student: {
      name: 'Jamel Eusebio',
      image: Student4,
      email: 'eusebio234@mail.com',
    },
    repaymentPeriod: '4 Weeks',
    loanPurpose: 'Need for project',
    loanAmount: 100,
    interest: '5%',
    status: 'Pending',
    date: '15/10/2024',
    returned: '0',
  },
  {
    id: 4,
    student: {
      name: 'Augustina Midgett',
      image: Student5,
      email: 'midgett245@mail.com',
    },
    repaymentPeriod: '4 Weeks',
    loanPurpose: 'Need for project',
    loanAmount: 200,
    interest: '5%',
    status: 'Denied',
    date: '15/10/2024',
    returned: '50',
  },
  {
    id: 5,
    student: {
      name: 'Geoffrey Mott',
      image: Student6,
      email: 'geofferey@mail.com',
    },
    repaymentPeriod: '4 Weeks',
    loanPurpose: 'Need for project',
    loanAmount: 100,
    interest: '5%',
    status: 'Approved',
    date: '15/10/2024',
    returned: '0',
  },
];

export const streetcreds = [
  {
    id: 0,
    studentName: 'John Doe',
    email: 'john123@gmail.com',
    title: 'Exemplary Participation in Class',
    date: '05/11/2024',
    amount: '500 $D',
    type: 'Highlight',
  },
  {
    id: 1,
    studentName: 'Flory Majid',
    email: 'flory123@gmail.com',
    title: 'Disruptive During Class',
    date: '05/11/2024',
    amount: '150 $D',
    type: 'Challenges',
  },
  {
    id: 2,
    studentName: 'Donart Redzepi',
    email: 'donart123@gmail.com',
    title: 'Excellent Teamwork',
    date: '05/11/2024',
    amount: '300 $D',
    type: 'Highlight',
  },
  {
    id: 3,
    studentName: 'Dante Kanake',
    email: 'dante123@gmail.com',
    title: 'Incomplete Assignments',
    date: '05/11/2024',
    amount: '500 $D',
    type: 'Challenges',
  },
  {
    id: 4,
    studentName: 'Jack Miller',
    email: 'jac123@gmail.com',
    title: 'Consistently Punctual',
    date: '05/11/2024',
    amount: '150 $D',
    type: 'Highlight',
  },
  {
    id: 5,
    studentName: 'Daniel Woyomi',
    email: 'daniel123@gmail.com',
    title: 'Disrespectful Language',
    date: '05/11/2024',
    amount: '300 $D',
    type: 'Challenges',
  },
  {
    id: 6,
    studentName: 'Flory John',
    email: 'flory123@gmail.com',
    title: 'Outstanding Improvement ',
    date: '05/11/2024',
    amount: '500 $D',
    type: 'Highlight',
  },
];

export const behaviourTypes = [
  {
    id: 0,
    title: 'Exemplary Participation in Class',
    description: 'Lorem ispum dolor sit amet consecutor',
    created_at: '05/11/2024',
    type: 'Highlight',
  },
  {
    id: 1,
    title: 'Disruptive During Class',
    description: 'Lorem ispum dolor sit amet consecutor',
    created_at: '05/11/2024',
    type: 'Challenges',
  },
  {
    id: 3,
    title: 'Excellent Teamwork',
    description: 'Lorem ispum dolor sit amet consecutor',
    created_at: '05/11/2024',
    type: 'Highlight',
  },
  {
    id: 4,
    title: 'Incomplete Assignments',
    description: 'Lorem ispum dolor sit amet consecutor',
    created_at: '05/11/2024',
    type: 'Challenges',
  },
  {
    id: 5,
    title: 'Consistently Punctual',
    description: 'Lorem ispum dolor sit amet consecutor',
    created_at: '05/11/2024',
    type: 'Highlight',
  },
  {
    id: 6,
    title: 'Disrespectful Language',
    description: 'Lorem ispum dolor sit amet consecutor',
    created_at: '05/11/2024',
    type: 'Challenges',
  },
];

export const classes = [
  {
    name: 'Weekly Math’s Class',
    startTime: '09:00',
    endTime: '12:00',
    students: studentsList,
  },
  {
    name: 'Weekly English Class',
    startTime: '09:00',
    endTime: '12:00',
    students: [],
  },
  {
    name: 'Weekly English Class',
    startTime: '09:00',
    endTime: '12:00',
    students: [],
  },
];

// const notifications = [
//   {
//     image: 'https://i.pinimg.com/736x/85/50/0f/85500fa7419b8ffeef481f3a3b1b5635.jpg',
//     title: 'Payment done successfully',
//     description: '',
//   },
//   {
//     image: 'https://i.pinimg.com/736x/95/76/19/95761985a0309a60cb8cbfbfb3104a63.jpg',
//     title: 'Payment done successfully',
//     description: '',
//   },
//   {
//     image: 'https://i.pinimg.com/736x/81/a1/33/81a1331ddad1f7e8cb159ade85d09ea7.jpg',
//     title: 'Payment done successfully',
//     description: '',
//   },
// ];

export const notifications = [
  {
    image: 'https://via.placeholder.com/150',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud e',
    time: new Date('2025-01-10'),
    read: false,
  },
  {
    image: 'https://via.placeholder.com/150',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud e',
    time: new Date('2025-01-09'),
    read: false,
  },
  {
    image: 'https://via.placeholder.com/150',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud e',
    time: new Date('2025-01-08'),
    read: true,
  },
  // {
  //   image: 'https://via.placeholder.com/150',
  //   title: 'New Feature Update',
  //   description: 'Explore our new feature for better user experience!',
  // },
  // {
  //   image: 'https://via.placeholder.com/150',
  //   title: 'Payment Successful',
  //   description: 'Your payment of $50 was processed successfully.',
  // },
  // {
  //   image: 'https://via.placeholder.com/150',
  //   title: 'Subscription Renewed',
  //   description: 'Your subscription has been renewed until Dec 2025.',
  // },
];
